export type NavTabsProps = {
  label: string
  id: string
}

type NavTabsWhitActionsProps = {
  tabs: NavTabsProps[]
  onClick: (selected: string) => void
  selectedTabId?: string
}

export const NavTabsWithActions = ({ tabs, onClick, selectedTabId }: NavTabsWhitActionsProps) => {
  return (
    <div className="flex w-full overflow-hidden bg-white shadow-[0_8px_10px_rgba(0,0,0,0.1)]">
      {tabs.map((tab) => {
        const isActive = tab.id === selectedTabId
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onClick(tab.id)}
            className={`relative flex-1 cursor-pointer border-b-[3px] px-8 py-4 text-center transition-colors ${
              isActive
                ? 'border-primary1 font-semibold text-primary1'
                : 'border-transparent font-normal text-[#2a2a2a] hover:bg-background2 hover:text-primary1'
            }`}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
